export default "e8931740949e1378.svg"